import React from 'react';
import Head from 'next/head';

export type ImageResourceHintsProps = {
  lcpImageUrl?: string | null;
};

const isAbsolute = (url?: string | null): boolean => {
  if (!url) {
    return false;
  }

  try {
    return Boolean(new URL(url).origin);
  } catch {
    return false;
  }
};

export const ImageResourceHints = ({
  lcpImageUrl,
}: ImageResourceHintsProps): JSX.Element => {
  const preloadUrl = isAbsolute(lcpImageUrl) ? lcpImageUrl : undefined;

  return (
    <Head>
      {preloadUrl && (
        <link rel="preload" as="image" href={preloadUrl} fetchPriority="high" />
      )}
    </Head>
  );
};

export default ImageResourceHints;
